import {
    createLocalStorageKey,
    createOptOutCookies,
    HD_PRIVACY_OPT_OUT,
    isCookie,
    hasNoOptOutStorage,
    OPT_OUT_COOKIE_NAME
} from "./util/PrivacyCookieUtil";
/* global cookieUtils  */

const isDebugMode = () => {
    try {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('debug') === 'true';
    } catch (e) {
        return false;
    }
};

const debugLog = (...args) => {
    if (isDebugMode()) {
        console.log('[GPC Debug]', ...args);
    }
};

const Service = {
    reportGpcSignal: (body) => {
        const endpoint = '/customer/gpc/v1/preference';
        return fetch(endpoint, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        });
    },
    getPrivacyOptOut: (svocId, userId) => {
        const endpoint = `/cdg/epc/v3/customer/${svocId}/user/${userId}/privacy-opt-out`;
        return fetch(endpoint, {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        });
    }
}
const Storage = {
    key: 'gpc',
    getGPC: () => {
        try {
            return JSON.parse(window.localStorage.getItem(Storage.key))
        } catch (e) {
            return null;
        }
    },
    setGPC: (obj) => {
        try {
            window.localStorage.setItem(Storage.key, JSON.stringify(obj))
        } catch (e) {
        }
    },
};

const Model = {
    setCustomer: () => {
        Model.Customer.isLoggedIn = window.THDCustomer.default.isLoggedIn || false;
        Model.Customer.svocID = window.THDCustomer.default.svocID || '';
        Model.Customer.mcvisID = window.THDCustomer.default.mcvisID || window.THDCustomer.default.guestUserID || '';
        Model.Customer.userID = window.THDCustomer.default.userID || '';
    },
    Customer: {},
    forStorage: (storageEntry) => {
        const storageObj = storageEntry || {
            loggedAsGuest: '',
            userIDs: []
        };
        storageObj.loggedAsGuest = !Model.Customer.isLoggedIn;

        if (Model.Customer.isLoggedIn) {
            if (storageObj.userIDs.indexOf(Model.Customer.userID) === -1) {
                storageObj.userIDs.push(Model.Customer.userID);
            }
        }
        return storageObj;
    },
    forAPI: () => ({
        mcvisId: Model.Customer.mcvisID,
        svocId: Model.Customer.svocID,
        userId: Model.Customer.userID
    })
}

function isGpcEnabled() {
   return window.navigator && window.navigator.globalPrivacyControl
}

if (isGpcEnabled()) {
    //GPC signal is on drop the cookie and update localStorage
    createOptOutCookies(cookieUtils.fed_CreateCookie, window.location.hostname);
    createLocalStorageKey();
} else if (window.localStorage.getItem(HD_PRIVACY_OPT_OUT)) {
    //GPC signal is off but localStorage key exists drop the cookie
    createOptOutCookies(cookieUtils.fed_CreateCookie, window.location.hostname);
} else if (isCookie(OPT_OUT_COOKIE_NAME) && hasNoOptOutStorage()) {
    //GPC signal is off and no localStorage key found but cookie exists, update localStorage
    createLocalStorageKey();
}

if (isGpcEnabled()) {
    if (window.THDCustomer && window.THDCustomer.default) {
        Model.setCustomer();
    }
    const storageEntry = Storage.getGPC();

    // if there's no local storage entry at all (first page hit with GPC enabled or after LocalStorage was cleared)
    // or if any of the previous userID's that were logged does not match the current userID (this will also cover the scenario when switching from guest to auth)
    if (!storageEntry || (Model.Customer.isLoggedIn && !storageEntry.userIDs.includes(Model.Customer.userID))) {
        Service.reportGpcSignal(Model.forAPI())
            .then(res => {
                if (res.ok) Storage.setGPC(Model.forStorage(storageEntry))
            }).catch((e) => console.log('GPC Request Failed: ', e));
    }
}

// Temporary addition to gauge expected traffic for privacy opt-out status checks
if (window.THDCustomer && window.THDCustomer.default) {
    Model.setCustomer();

    if (Model.Customer.isLoggedIn && Model.Customer.svocID && Model.Customer.userID) {
        Service.getPrivacyOptOut(Model.Customer.svocID, Model.Customer.userID)
            .then(res => {
                if (res.ok) {
                    return res.json();
                }
            })
            .then(data => {
                if (data) {
                    debugLog('Privacy opt-out status:', data);
                }
            })
            .catch((e) => debugLog('Get Privacy Opt-Out Failed: ', e));
    }
}
